import { PROTOCOL_ID, PROTOCOL_VERSION, } from "./types.js";
import { parseBridgeMessage } from "./validation.js";
function messageId() {
    if (typeof globalThis.crypto?.randomUUID === "function") {
        return globalThis.crypto.randomUUID();
    }
    return `msg-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
}
export function createBridgeMessage(type, payload, options = {}) {
    const version = options.version ?? PROTOCOL_VERSION;
    const candidate = {
        protocol: PROTOCOL_ID,
        version,
        id: options.id ?? messageId(),
        type,
        timestamp: options.timestamp ?? Date.now(),
        ...(options.replyTo === undefined ? {} : { replyTo: options.replyTo }),
        payload,
    };
    return parseBridgeMessage(candidate, {
        supportedVersions: [version],
    });
}
export function serializeBridgeMessage(message) {
    return JSON.stringify(parseBridgeMessage(message));
}
//# sourceMappingURL=messages.js.map